<template>
  <div>
    <v-toolbar app class="elevation-0" aria-label="main">
      <v-img src="@/assets/primerica-logo.svg" height="40" alt="Primerica Beta" />
      <v-spacer />
      <v-toolbar-items class="hidden-sm-and-down">
        <v-col align-center justify-center d-flex ml-5 mr-5 pl-5 pr-5>
          <a href="javascript:void(0)" class="sign-in" @click="goToLogin">
            {{ $t('L_sign_in') }}
          </a>
        </v-col>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script lang="ts">
import type { LOCALES } from '@/shared/models/constants.models';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapActions, mapState } from 'pinia';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SectionHeader',
  computed: {
    ...mapState(useGlobalStore, {
      langName: 'langName',
      locale: 'locale',
    }),
  },
  methods: {
    ...mapActions(useGlobalStore, ['goToLogin']),
    changeLocale(lang: string) {
      this.locale = lang as LOCALES;
      this.$i18n.locale = lang;
    },
  },
});
</script>

<style lang="scss" scoped>
.v-toolbar__title {
  font-size: 16px;
  font-weight: normal !important;
}
.sign-in {
  color: #333 !important;
  font-weight: normal !important;
}
</style>
